import moment from 'moment';

export function getDateObject(datetime?: moment.MomentInput) {
    const dateObject = moment.isMoment(datetime) ? datetime : moment(datetime || undefined);

    return dateObject;
}
